<script setup>
import { inject, ref } from 'vue';
import { __, getFormValuesFromLocalStorage, numbersType } from '@/utils';
import MixedSim from '@components/successPage/mixedSim.vue';
import NoEsim from '@components/successPage/noEsim.vue';
import OnlyEsim from '@components/successPage/onlyEsim.vue';

const { registrationData } = inject('step');

const localStorageValues = getFormValuesFromLocalStorage();
const clientType = localStorageValues.activeTab === 'Business Client' ? 'company' : 'subscriber';
const FirstName = ref(localStorageValues[`${clientType}FirstName`]);
const simActivationType = ref(1);

const activationProccessType = () => {
    let hasEsim = false;
    let hasNonEsim = false;
    
    registrationData.value.subscribers?.forEach(entry => {
        if (entry.sim?.is_esim) {
            hasEsim = true;
        } else {
            hasNonEsim = true;
        }
    });

    if (hasEsim && !hasNonEsim) {
        simActivationType.value = 2; // Only eSIM selected
    } else if (!hasEsim && hasNonEsim) {
        simActivationType.value = 1; // No eSIM selected
    } else {
        simActivationType.value = 3; // Mixed
    }
}

simActivationType.value = 1;

const message = ref(registrationSuccess.mixed)
const messagePorted = ref(registrationSuccess.mixed_ported)
const messageMixed= ref(registrationSuccess.mixed_ported_new_line)

activationProccessType();
</script>
<template>
    <div class="congrats">
        <div class="congrats__inner">
            <div class="congrats__heading">
                <h3 class="gradient">{{ __('Congratulations,') }} {{ FirstName }}</h3>
                <h3>{{ __('The service and order were carried out successfully!') }}</h3>
            </div>

            <div class="congrats__order-number">
                <p>
                    <strong>{{ __('Order Number:') }}</strong> {{ registrationData?.quote?.number }}
                </p>
            </div>
            
            <div class="activation-header" v-if="simActivationType === 3">
                <p>
                    <span v-html="message" v-if="numbersType(registrationData.subscribers) === 'new_line'"></span>

                    <span v-html="messagePorted" v-if="numbersType(registrationData.subscribers) === 'ported'"></span>

                    <span v-html="messageMixed" v-if="numbersType(registrationData.subscribers) === 'mixed'"></span>
                </p>
            </div>

            <h4>{{ __('So what happens now?') }}</h4>

            <!-- in case there is not esim cards -->
            <NoEsim v-if="simActivationType === 1" />
            <!-- in case there is only esim cards -->
            <OnlyEsim v-if="simActivationType === 2" />
            <!-- in case there is esim and non esim cards -->
            <MixedSim v-if="simActivationType === 3" />
        </div>
    </div>
</template>
